







































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import {
  checkUserPassword,
  setNewPassword,
  setPasswordOfTheSharedUsers,
} from "@/data/repository/UserRepository";

import User from "@/data/models/User";
import { getSharedEmailAddressInfo } from "@/data/repository/SharedEmailAddressRepository";
import { auth } from "firebase";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class SetNewPasswordComponent extends Vue {
  isLoading = false;

  oldPassword = "";
  newPassword = "";
  newPasswordRepeated = "";

  oldPasswordError: string[] = [];
  newPasswordError: string[] = [];
  newPasswordRepeatedError: string[] = [];

  showOldPassword = false;
  showNewPassword = false;
  showNewPasswordRepeated = false;

  canClose: boolean | undefined = undefined;
  skipOldPasswordChecks = false;

  user!: User;

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Watch("newPassword")
  onNewPasswordChange() {
    this.newPasswordError = [];
  }

  @Watch("newPasswordRepeated")
  onNewPasswordRepeatedChange() {
    this.newPasswordRepeatedError = [];
  }

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  async show(user: User, canClose?: boolean, skipOldPasswordChecks?: boolean) {
    this.user = user;
    this.newPassword = "";
    this.newPasswordRepeated = "";

    this.skipOldPasswordChecks = skipOldPasswordChecks ?? false;
    this.canClose = canClose;

    this.baseDialogComponent.show({
      title: this.$t("resetPassword.setNewPassword").toString(),
      positiveButtonText: this.$t("resetPassword.setNewPassword").toString(),
      negativeButtonText: canClose ? this.$t("common.abort").toString() : null,
      closeOnSave: false,
      persistent: !canClose || skipOldPasswordChecks,
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  toggleShowOldPassword() {
    this.showOldPassword = !this.showOldPassword;
  }

  toggleShowNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleShowNewPasswordRepeated() {
    this.showNewPasswordRepeated = !this.showNewPasswordRepeated;
  }

  async onCancel() {
    if (this.skipOldPasswordChecks) {
      await auth().signOut();
    }

    return;
  }

  async onSave() {
    const newPassword = this.newPassword;
    const newPasswordRepeated = this.newPasswordRepeated;

    this.isLoading = true;
    const isOldPasswordCorrect = this.skipOldPasswordChecks
      ? true
      : (
        await checkUserPassword(this.user.id, this.oldPassword)
      ).isCorrectPassword;

    if (!isOldPasswordCorrect) {
      this.oldPasswordError = [
        this.$t("resetPassword.errorWrongPassword").toString(),
      ];

      this.isLoading = false;
      return;
    }

    if (newPassword.length < 8) {
      this.newPasswordError = [
        this.$t("resetPassword.errorMinPasswordLength").toString(),
      ];
      this.isLoading = false;
      return;
    }

    if (newPassword != newPasswordRepeated) {
      this.newPasswordRepeatedError = [
        this.$t("resetPassword.errorPasswordNoMatch").toString(),
      ];
      this.isLoading = false;
      return;
    }

    if (this.user.sharedEmailAddressId && !this.skipOldPasswordChecks) {
      const sharedEmailAddressInfo = await getSharedEmailAddressInfo(this.user.sharedEmailAddressId);

      if (sharedEmailAddressInfo) {
        await setPasswordOfTheSharedUsers(sharedEmailAddressInfo, newPassword, false);
      }
    }
    else {
      await setNewPassword(
        this.user.id, 
        newPassword, 
        this.user
      );
    }

    this.isLoading = false;

    this.baseDialogComponent.isShowing = false;
    this.resolve && this.resolve(true);
  }
}
